<template>
  <div
    v-if="!hasSubscription || show"
    data-el="upgrade-banner"
    :data-addon="addon"
    :data-highlight-feature="highlightFeature"
    :data-highlight-limit="highlightLimit"
  >
    <slot>
      <AlertCard
        :dismissible="false"
        :variant="Variant.upgrade"
        :flat="flat"
        :icon="'paidFeature'"
        :title="subtitle"
        :text="text"
      >
        <template v-if="$slots.image" #image>
          <slot name="image" />
        </template>
        <template #button>
          <UpgradeButtonFeature
            :data-id="dataId"
            :addon="addon"
            :btn-text="btnText"
            :highlight-feature="highlightFeature"
            :highlight-limit="highlightLimit"
          />
        </template>
      </AlertCard>
    </slot>
  </div>
</template>
<script lang="ts" setup>
// TODO handle product type prefers etc
import { computed } from 'vue';
import { useStore3 } from '~/store/main';
import { storeToRefs } from 'pinia';
import AlertCard from './tw/AlertCard.vue';
import { Variant } from '~/store/_types';
import type {
  PlanFeatures,
  PlanLimits,
  SubscriptionDto,
} from '@mailslurp/admin-sdk';
import type { UpgradeAddon } from '~/lib/services/types';
import UpgradeButtonFeature from './pricing/UpgradeButtonFeature.vue';
import { addonToPlanAddonExclusive } from '~/lib/services/upgradeLinks';

const props = withDefaults(
  defineProps<{
    dataId: string;
    subscriptionProperty?: keyof SubscriptionDto;
    label?: string;
    flat?: boolean;
    show?: boolean;
    addon?: UpgradeAddon;
    description?: string;
    highlightFeature?: keyof PlanFeatures;
    highlightLimit?: keyof PlanLimits;
    btnText?: string;
    text?: string;
  }>(),
  {
    subscriptionProperty: undefined,
    label: 'feature',
    addon: undefined,
    highlightFeature: undefined,
    highlightLimit: undefined,
    description: '',
    btnText: '',
    text: '',
  },
);
const store3 = useStore3();
const { subscription, userAddons } = storeToRefs(store3);

const hasSubscription = computed<boolean>(() => {
  const sub = subscription.value;
  const addons = userAddons.value;
  const subscriptionAddon = props.addon
    ? addonToPlanAddonExclusive(props.addon)
    : undefined;
  if (props.subscriptionProperty && sub) {
    return !!sub[props.subscriptionProperty];
  } else if (subscriptionAddon && addons) {
    return addons.includes(subscriptionAddon);
  } else {
    return !!sub;
  }
});
const subtitle = computed(() => {
  return props.description || `Upgrade to enable ${props.label}`;
});
</script>
